<template>
	<div>
		<div class="topup-header"> 
			<img class='icon' :src="purchaseEvent.extension.eventIcon">
			<span>{{purchaseEvent.title}}</span>
			<span class='tip'>（{{purchaseEvent.extension.eventRule}}）</span>
		</div>
		<div class="product" :class='productindex == list.length - 1 ?"last":""' v-for="(products,productindex) in menuList" :key="products.sku">
			<div class="p-checkbox"></div>
			<div class="p-name">
				<div class="p-left">
					<div  class="p-img" style="cursor: pointer;" @click="goDetail(products)">
						<img class="img" src="@/assets/order/errorImg2.png" v-real-img="products.image_path_big">
					</div>
				</div>
				<div class="p-right">
					<div class="p-name1">
						<div style="cursor: pointer;" class="p-name-span" @click="goDetail(products)">
							<span class='span_name'> {{products.name}}</span>
							<div class='hotlist'>
								<span v-if='products.is_hot == 1' class="hot">热销<b class='no_mobile'>(Hot)</b></span>
								<template v-if='products.is_hot == 1'>&nbsp;</template>
								<span v-if='products.is_new == 1' class="hot">新品<b class='no_mobile'>(New)</b></span>
								<template v-if='products.is_new == 1'>&nbsp;</template>
								<span v-if='products.is_promotion == 1' class="hot">促销<b class='no_mobile'>(Promotion)</b></span>
							</div>
						</div>
					</div>
					<div class="other">
						<span v-if="isOriginalPrice==false">点数: {{products.specproducts[0].pv}}</span>
						<span>{{products.specproducts[0].specs[0].name}}: {{products.specproducts[0].specs[0].value}}</span>
						<span v-if="products.specproducts[0].pt>0 && isOriginalPrice==false">PT: {{products.specproducts[0].pt}}</span>
					</div>
				</div>
			
			</div>
			<div class="price">{{isPVOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price}}</div>
			<div class="count">
				<template v-if='noStockText(products)'>
					<span class='show_nostock' v-html="noStockText(products)"></span>
				</template>
				<div :class="{'offset':isExchange(products)&&isMobile } " v-else>
					<template v-if='isMobile'>
						<buyCart @reachMax='reachMax' :maxLimit='maxLimit' v-model="products.num" :mainSku='purchaseEvent.mainSku' :iscart='2' :product="products" class='products_add' style='display:inline-block' @showPromoCode='$emit("showPromoCode",$event)'></buyCart>
					</template>
					<template v-else>
						<buyCart @reachMax='reachMax' :maxLimit='maxLimit' v-model="products.num" :mainSku='purchaseEvent.mainSku' :product="products" style='display:inline-block' @showPromoCode='$emit("showPromoCode",$event)'></buyCart>
					</template>
					<div class="point_mobile" v-if='isMobile'>
						<template v-if="isExchange(products)">
							<select-point :products='products' :poinBalance='poinBalance' @showChoosePTList="$emit('showChoosePTList',$event)"></select-point>
						</template>
					</div>
				</div>

			</div>
			<div class="sub-total no_mobile">￥{{((isPVOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price)*(products.num-(isNaN(products.point / products.pt)?0:products.point / products.pt))).toFixed(2)}}</div>
			<div class="sub-point no_mobile">
				<template v-if="isExchange(products)&&!isMobile">
					<select-point :products='products' :poinBalance='poinBalance' @showChoosePTList="$emit('showChoosePTList',$event)"></select-point>
				</template>
			</div>
		</div>
		<Modal v-model='showDetail' width='80vw' footer-hide>
			<product-detail v-if='showDetail' :product='showProduct' :isPVOriginalPrice='isPVOriginalPrice'/>
		</Modal>
	</div>
	
</template>

<script>
	import selectPoint from "@/components/order/selectPoint";
	import buyCart from "@/components/order/buyCart";
	import productDetail from './ProductModal'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		props:{
			isOriginalPrice: {
				type:Boolean,
				default:false,
			},
			isPVOriginalPrice: {
				type:Boolean,
				default:false,
			},
			isMobile:{
				type:Boolean,
				default:false,
			},
			noStockText:{
				type:Function,
			},
			isExchange:{
				type:Function,
			},
			poinBalance:{
				type:Number,
				default:0,
			},
			purchaseEvent:{
				type:Object,
				default:()=>({}),
			},
			default_store_id:{
				type:String,
				default:'501'
			},
		},
		data() {
			return {
				showProduct:{},
				showDetail:false,
				list:[{}]
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			selectPoint,
			buyCart,
			productDetail,
		},
		computed: {
			...mapState({
				cartInfo: (state) => state.order.cartInfo,
				productStockInfo: (state) => state.order.productStockInfo,
			}),
			mainProduct(){
				let mainProduct = this.cartInfo.value.detail.find(item=>item.sku == this.purchaseEvent.mainSku)
				return mainProduct
			},
			maxLimit(){
				let {defaultNum,perNum} = this.purchaseEvent
				return Math.floor(this.mainProduct.num * defaultNum / perNum)
			},
			menuList() {
				if (!this.list)return []
				let productListArr = new Array();
				let op = this.isPVOriginalPrice;
				let additionals = this.mainProduct.additionals || []
				let stockList = this.productStockInfo.value.find(item=>item.warehouse == this.default_store_id)?.stock
				this.list.forEach((product,index)=>{
					let productPrice = product.specproducts ? product.specproducts[0] : {};
					var Price = op
						? productPrice.original_price
						: productPrice.price;
					product.price = Price;
					let item = additionals.find(item=>item.sku == product.sku)
					product.point = item?.point || 0
					product.pt = item?.pt || 0;
					product.num = item?.num || 0;
					
					product.stock = stockList.find(i=>i.sku == product.sku)?.stock || 0

					productListArr.push(product);
				})
				return productListArr;
			},
		},
		methods: {
			...mapActions([
				'getPurchaseProductsAction'
			]),
			async initData(){
				let skus = this.purchaseEvent.additionalList.map(item=>item.addValue)
				let res = await this.getPurchaseProductsAction({skus,mainSku:this.purchaseEvent.mainSku})
				this.list = res
			},
			goDetail(product){
				this.showProduct = product
				this.showDetail = true

			},
			reachMax(){
				this.$Toast.show(this.purchaseEvent.extension.maxTip, { duration:  1500 });
			},
		},
	}
</script>

<style lang='scss' scoped>
	@import "@/style/common";
	@import "@/style/mixin";
.topup-header {
	margin-top:10px;
	text-align:left;
	font-size:20px;
	font-weight:bold;
	color:$blue;
	margin-left: 20px;
	display:flex;
	align-items: center;

	.icon {
		width:25px;
		height:25px;
		margin-right: 10px;
	}
	.tip {
		font-size:14px;
		font-weight:normal;
	}
}
	.checkbox {
		width: 5%;
		white-space: nowrap;
	}
	.img {
		width: 120px;
		height: auto;
		padding: 10px;
		display: block; // height: 80px;
		min-height: 80px;
	}
	.p-img{
		width: 10%;
	}
	.p-left{
		float: left;
		margin-right: 10px;
	}
	.p-right{
		padding: 20px;
	}
	.p-checkbox {
		width:60px;
	}
	.product-header {
		font-weight:bold;
		padding:10px 0;
	}
	.p-name {
		text-align: left;
		position: relative;
		width: 40%;
		.p-name-span {
			width: 50%;
			position: relative;
			display: inline-block;
			.span_name {
				display: inline-block;
				@include fontSize($font-size-15);
			}
		}
		.exchange {
			margin-left: 30px;
			padding: 2px 4px;
			background-color: $theme-color;
			border-color: $theme-color;
			color: white;
			border-radius: 4px;
			cursor: pointer;
			&:hover {
				background-color: #c99ed3e8;
				border-color: #c99ed3e8;
			}
		}
	}
	.count,
	.sub-total,
	.sub-dh {
		width: 15%;
	}
	.price {
		width: 10%;
	}
	.sub-point{
		position: relative;
	}

	.delete {
		color: indigo;
		cursor: pointer;
		display: inline-block;
		margin-top: 5px;
	}
	.show_nostock {
		// font-weight: bold;
		@include fontSize($font-size-13);
		line-height: 24px;
		padding: 3px 5px;
		background-color: #ccc;
		color: white;
		border-radius: 5px;
		white-space: nowrap;
		em {
			font-style: normal;
		}
	}
	.show_nogiven {
		color:red;
	}
	.product {
		display:flex;
		align-items:center;
		.count{
			position: relative;
		}
		th {
			padding: 10px;
			font-weight: 500;
			@include fontSize($font-size-14);
		}
		.other {
			padding-top: 3px;
			color: #999;
			span {
				margin-right: 10px;
			}
		}
	}
	.last {
		border-bottom: 1px solid #eaeaea;
	}
	.hotlist {
	    margin-top: 5px;
	    margin-bottom: 5px;
	}
	.hot {
		display: inline-block; // width: 36px;
		// height: 18px;
		line-height: 18px; //margin-left: 4px;
		@include fontSize($font-size-13);
		color: #fff;
		text-align: center;
		background-color: $theme-color;
		padding: 3px 10px;
		border-radius: 10px;
		//margin: 0px 5px;
		&:first-child {
			margin-left: 0;
		}
		b {
			font-weight: 500;
			@include fontSize($font-size-12);
		}
	}
</style>